import AuthLayout from '../layouts/AuthLayout.vue'

const authRoutes = {
  path: '/auth',
  component: AuthLayout,
  children: [
    {
      name: 'login',
      path: 'login',
      component: () => import('../pages/auth/Login.vue'),
    },
    {
      name: 'register',
      path: 'register',
      component: () => import('../pages/auth/Register.vue'),
    },
    {
      name: 'reset-password',
      path: 'reset-password',
      component: () => import('../pages/auth/ResetPassword.vue'),
    },
    {
      name: 'verify-code',
      path: 'verify-code',
      component: () => import('../pages/auth/VerifyCode.vue'),
    },
    {
      name: 'logout',
      path: 'logout',
      component: () => import('../pages/auth/Logout.vue'),
    },
    {
      name: 'tcp',
      path: 'terms-conditions-privacy',
      component: () => import('../pages/termsConditionsAndPolicies/TermsConditionsAndPolicies.vue'),
    },
    {
      path: '',
      redirect: { name: 'login' },
    },
  ],
}

export default authRoutes
